import { Col, Row } from 'react-bootstrap';
import Checkbox from '../../../../../presentation/components/Checkbox';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';
import store from '../../../../../store';
import { LABEL_PLACEMENT } from 'baseui/checkbox';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/button';
import React, { useState } from 'react';
import { styled } from 'baseui';
import { useTranslation } from 'react-i18next';
import CityField from './CityField';
import ZipField from './ZipField';
import StreetField from './StreetField';
import HouseNumberField from './HouseNumberField';
import { SetValueConfig } from 'react-hook-form';

const CheckboxRow = styled(Row, {
  marginBottom: '34px'
});

interface HouseAddressFormProps {
  formControl: any;
  errors: any;
  setValue: (
    name: 'street' | 'houseNr' | 'zip' | 'city',
    value: any,
    options?: SetValueConfig
  ) => void;
  onSubmit: (data: any, e?: React.BaseSyntheticEvent) => void;
}

const HouseAddressForm: React.FC<HouseAddressFormProps> = ({
  formControl,
  errors,
  setValue,
  onSubmit
}) => {
  const { t } = useTranslation();
  const [shouldCopyAddress, setShouldCopyAddress] = useState<boolean>(false);

  return (
    <form noValidate onSubmit={onSubmit}>
      <Row className="justify-content-center mt-4">
        <Col xs={10} lg={9}>
          <fieldset>
            <legend id="same-address-label" className="visually-hidden">
              {t('page.houseAddress.sameAddressCheckboxLabel')}
            </legend>
            <CheckboxRow className="mt-3">
              <Col lg={10}>
                <Checkbox
                  checked={shouldCopyAddress}
                  onChange={(e) => {
                    TrackerUtil.trackCheckboxClick('property_checkbox_equal', 'checkbox_equal');

                    if (e.currentTarget.checked) {
                      const ia = store.getState().onboardingInfo.invoiceAddress;
                      const options = { shouldValidate: true };
                      setValue('street', ia.street, options);
                      setValue('houseNr', ia.houseNumber, options);
                      setValue('zip', ia.zip, options);
                      setValue('city', ia.city, options);
                    }
                    setShouldCopyAddress(e.currentTarget.checked);
                  }}
                  labelPlacement={LABEL_PLACEMENT.right}
                  additionalTestId="same-address"
                  aria-labelledby="same-address-label"
                >
                  {t('page.houseAddress.sameAddressCheckboxLabel')}
                </Checkbox>
              </Col>
            </CheckboxRow>
          </fieldset>

          <Row>
            <Col lg={7}>
              <Row>
                <Col lg={4}>
                  <ZipField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
                <Col lg={8}>
                  <CityField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
              </Row>
            </Col>
            <Col lg={5}>
              <Row>
                <Col lg={9}>
                  <StreetField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
                <Col lg={3}>
                  <HouseNumberField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-center py-5">
        <Col className="text-center col-auto">
          <Button size={SIZE.large} type="submit" additionalTestId="next">
            {t('nextBtnText')}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default HouseAddressForm;
